import '../../settings.mjs';
import { ENV } from '@pixi/constants';
import { settings } from '@pixi/settings';
var unknownContext = {};
var context = unknownContext;
function getTestContext() {
  var _context;
  if (context === unknownContext || (_context = context) !== null && _context !== void 0 && _context.isContextLost()) {
    var canvas = settings.ADAPTER.createCanvas();
    var gl;
    if (settings.PREFER_ENV >= ENV.WEBGL2) {
      gl = canvas.getContext("webgl2", {});
    }
    if (!gl) {
      gl = canvas.getContext("webgl", {}) || canvas.getContext("experimental-webgl", {});
      if (!gl) {
        gl = null;
      } else {
        gl.getExtension("WEBGL_draw_buffers");
      }
    }
    context = gl;
  }
  return context;
}
export { getTestContext };